import {useMemo} from 'react'

import {useUserInfoContext} from '$contexts/member/userInfoStatus'
import useWebAppApiQuery from '$hooks/insurance/useWebAppApiQuery'
import {getPeerAverageBenefitRankQuery} from '$queries/insurance/resourceQuery'
import {getPeerAge} from '$share/utils/insurance'

export function usePeerAverageBenefitRankQuery({benefitAmounts}: {benefitAmounts: string}) {
    const {userInfo} = useUserInfoContext()
    const {isLoading, isError, isFetched, data} = useWebAppApiQuery(
        getPeerAverageBenefitRankQuery.query({
            params: {
                gender: userInfo.gender,
                birth: getPeerAge(userInfo.age),
                benefitAmounts,
            },
        }),
    )

    const result = useMemo(
        () => ({
            isLoading,
            isError,
            isFetched,
            data,
        }),
        [data, isError, isFetched, isLoading],
    )

    return result
}
